module.exports = __webpack_public_path__ + "static/media/MT.2eebfa2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MT.svg
// module id = 319
// module chunks = 0